import p1 from "./player-portraits/player-portrait-1.svg";
import p2 from "./player-portraits/player-portrait-2.svg";
import p3 from "./player-portraits/player-portrait-3.svg";
import p4 from "./player-portraits/player-portrait-4.svg";
import p5 from "./player-portraits/player-portrait-5.svg";
import p6 from "./player-portraits/player-portrait-6.svg";
import p7 from "./player-portraits/player-portrait-7.svg";
import p8 from "./player-portraits/player-portrait-8.svg";
import p9 from "./player-portraits/player-portrait-9.svg";
import p10 from "./player-portraits/player-portrait-10.svg";
import p11 from "./player-portraits/player-portrait-11.svg";
import p12 from "./player-portraits/player-portrait-12.svg";
import p13 from "./player-portraits/player-portrait-13.svg";
import p14 from "./player-portraits/player-portrait-14.svg";
import p15 from "./player-portraits/player-portrait-15.svg";
import p16 from "./player-portraits/player-portrait-16.svg";
import p17 from "./player-portraits/player-portrait-17.svg";
import p18 from "./player-portraits/player-portrait-18.svg";
import p19 from "./player-portraits/player-portrait-19.svg";
import p20 from "./player-portraits/player-portrait-20.svg";
import p21 from "./player-portraits/player-portrait-21.svg";
import p22 from "./player-portraits/player-portrait-22.svg";
import p23 from "./player-portraits/player-portrait-23.svg";
import p24 from "./player-portraits/player-portrait-24.svg";
import p25 from "./player-portraits/player-portrait-25.svg";
import p26 from "./player-portraits/player-portrait-26.svg";
import p27 from "./player-portraits/player-portrait-27.svg";
import p28 from "./player-portraits/player-portrait-28.svg";
import p29 from "./player-portraits/player-portrait-29.svg";
import p30 from "./player-portraits/player-portrait-30.svg";
import p_default from "./player-portraits/player-portrait-default.svg";
import badge_img from "./badge.svg";
import { SECRET_ICON_PATTERN, secretIconUrl } from "../secretIcons";
import { PHOTO_ICON_PATTERN, photoIconUrl } from "../photoIcons";

const publicPortraits: Record<string, string> = {
  p_default,
  p1,
  p2,
  p3,
  p4,
  p5,
  p6,
  p7,
  p8,
  p9,
  p10,
  p11,
  p12,
  p13,
  p14,
  p15,
  p16,
  p17,
  p18,
  p19,
  p20,
  p21,
  p22,
  p23,
  p24,
  p25,
  p26,
  p27,
  p28,
  p29,
  p30,
};
/** Secret icons (see secretIcons.ts) and photo looks (see photoIcons.ts) are loaded from the server instead of being bundled. */
const portraits: Record<string, string> = new Proxy(publicPortraits, {
  get: (target, id) =>
    typeof id === "string" && SECRET_ICON_PATTERN.test(id)
      ? secretIconUrl(id)
      : typeof id === "string" && PHOTO_ICON_PATTERN.test(id)
      ? photoIconUrl(id)
      : target[id as string],
});
export default portraits;

export const defaultPortrait = "p_default";

export const unlockedPortraits: string[] = Array.from({ length: 30 }, (_, i) => "p" + (i + 1));

const publicAltText: Record<string, string> = {
  p_default: "No icon selected.",
  p1: "A smiling stranger with swept auburn hair, round glasses and a green collared shirt.",
  p2: "A grinning stranger with a big afro, hoop earrings and a purple hoodie.",
  p3: "A kind stranger with a silver bun, round glasses, pearls and a lilac cardigan.",
  p4: "A bearded stranger in an orange beanie and a red flannel shirt.",
  p5: "A stranger with long black hair and bangs, red lipstick and a navy blazer.",
  p6: "A cool stranger with a buzz cut and dark sunglasses.",
  p7: "A cheerful stranger with brown curls, freckles and denim overalls.",
  p8: "A bald stranger with a moustache, square glasses and a red bow tie.",
  p9: "A punk stranger with a red mohawk and a studded leather jacket.",
  p10: "A stranger with a teal bob and big red headphones.",
  p11: "A stranger in a fedora with a goatee and a tan trench coat.",
  p12: "A smiling stranger in a rose headscarf and a cream shirt.",
  p13: "A stranger with long dark hair, stubble and a blue shirt.",
  p14: "A stranger with blonde pigtails and a striped shirt.",
  p15: "A stranger with thick white hair and bushy eyebrows in a green cardigan.",
  p16: "A pirate-like stranger with spiky blond hair, an eyepatch and a red scarf.",
  p17: "A stranger in a red beret with a dark bob and a striped shirt.",
  p18: "A friendly fox in a navy jacket.",
  p19: "A cheerful robot with glowing teal eyes.",
  p20: "An astronaut in a white suit among the stars.",
  p21: "A grinning pilot in a brown leather flying cap with goggles on the forehead and a shearling collar.",
  p22: "A war correspondent in a fedora with a press card in the band and a tan trench coat.",
  p23: "A codebreaker with finger-waved hair, round glasses and big old-fashioned headphones.",
  p24: "A field nurse in a white veil cap with a blue stripe and a grey-blue dress with a white apron.",
  p25: "A courier in a flat cap and a red scarf with a dark wool coat and a day of stubble.",
  p26: "A man in a bowler hat with a thick moustache and a dark overcoat with the collar turned up.",
  p27: "A naval officer in a white peaked cap and a navy double-breasted jacket with gold buttons.",
  p28: "A factory worker in a teal headscarf tied at the side and a khaki work coverall.",
  p29: "A soldier in a round steel helmet with a chin strap and an olive tunic.",
  p30: "A 1920s woman in a cream cloche hat with a dark bob, pearls and drop earrings.",
};
export const portraitsAltText: Record<string, string> = new Proxy(publicAltText, {
  get: (target, id) =>
    typeof id === "string" && SECRET_ICON_PATTERN.test(id)
      ? "A secret look."
      : typeof id === "string" && PHOTO_ICON_PATTERN.test(id)
      ? "A photo."
      : target[id as string],
});

export const badge = badge_img;
